<template>
	<v-main>
		<div style="padding:10px;">
			<center>Please wait while we take you to the {{direction}} {{type}}</center>
		</div>
	</v-main>
</template>

<style scoped>
* {
	font-family: "Roboto";
}
</style>

<script>
/* eslint-disable */

export default {
	props: [
		"tenantSlug",
		"experienceSlug", //
		"type", //
		"direction", //
		"id", //
		"trackId",
		"presentationScheduleId",
		"presentationId" //
	],
	data() {
		return {};
	},
	mounted() {
		if (this.type == "conversation") {
			this.direction = "";
		}
		setTimeout(() => {
			this.passThru();
		}, 2500);
	},
	methods: {
		passThru() {
			if (this.type == "presentation") {
				this.$router.push(
					"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/presentation/" +
						this.trackId +
						"/" +
						this.presentationScheduleId +
						"/" +
						this.presentationId
				);
			} else if (this.type == "booth") {
				this.$router.push("/" + this.tenantSlug + "/" + this.experienceSlug + "/" + this.type + "/" + this.id);
			} else if (this.type == "conversation") {
				this.direction = "";
				this.$router.push("/" + this.tenantSlug + "/" + this.experienceSlug + "/meeting/" + this.id);
			}
		}
	}
};
</script>
